require.register("modules/m0x/a05/page-56/page-56", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_56 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_56;


  
});

